export const getImageStyleListRowItemUtil = () => ({
  borderTopLeftRadius: '6px',
  borderBottomLeftRadius: '6px',
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0
})
